<template>
  <spinner-container :loading="loading">
    <back-btn />
    <v-row justify="center">
      <v-col cols="12" md="6">
        <admin-form :admin="adminData" @emitAdminData="updateAdmin" />
      </v-col>
    </v-row>
  </spinner-container>
</template>

<script>
import AdminForm from "@/components/admin/AdminForm";
import { mapState } from "vuex";
import SpinnerContainer from "@/components/container/SpinnerContainer";
import BackBtn from "../../components/navigation/BackBtn.vue";

export default {
  components: {
    AdminForm,
    SpinnerContainer,
    BackBtn,
  },
  data: () => ({
    cumps: [
      {
        text: "Home",
        disabled: false,
        href: "/",
      },
      {
        text: "Admins",
        disabled: false,
        href: "/admins",
      },
      {
        text: "Admin Form",
        disabled: true,
      },
    ],
  }),
  computed: {
    ...mapState("Admin", ["adminData"]),
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    updateAdmin(payload) {
      this.$store.dispatch("Admin/updateAdmin", payload).then(() => {
        this.$router.push({ name: "Admin" });
      });
    },
  },
  created() {
    this.$store.dispatch("Admin/getAdminData", this.$route.params.id);
  },
};
</script>
